import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ProTable, Link } from 'components/layout';
import { EditButton } from 'components/button';
import DeleteButton from './DeleteButton';
import {
  useHasScopeTypeInProject,
  // useActionColumn,
  useTeamMemberTypesFilters,
} from 'hooks';
import { stringSorter } from 'utils';

const TeamTable = ({ data, loading }) => {
  const { projectId } = useParams();
  const { hasScopeType } = useHasScopeTypeInProject('WRITE_TEAM');
  const filters = useTeamMemberTypesFilters();
  // const actionColumn = useActionColumn();

  const columns = [
    {
      title: 'Type',
      dataIndex: ['teamMemberType', 'name'],
      filters,
      onFilter: true,
      sorter: (a, b) => a?.teamMemberType?.seq - b?.teamMemberType?.seq,
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Name',
      dataIndex: ['user', 'name'],
      sorter: (a, b) => stringSorter(a.user.name, b.user.name),
    },
    {
      title: 'Net ID',
      dataIndex: ['user', 'netId'],
      sorter: (a, b) => stringSorter(a.user.netId, b.user.netId),
    },
    {
      title: 'Faculty / School',
      dataIndex: ['user', 'faculty', 'abbreviation'],
      sorter: (a, b) =>
        stringSorter(
          a.user.faculty?.abbreviation,
          b.user.faculty?.abbreviation
        ),
    },
    {
      title: 'Department',
      dataIndex: ['user', 'department', 'abbreviation'],
      sorter: (a, b) =>
        stringSorter(
          a.user.department?.abbreviation,
          b.user.department?.abbreviation
        ),
    },
    hasScopeType && {
      title: 'Action',
      width: '250px',
      render: (_, item) => {
        const obj = {
          children: (
            <>
              <Link to={`/projects/${projectId}/team/${item.id}/edit`}>
                <EditButton />
              </Link>
              {/* <EditButton
                key={item.id}
                id={item.id}
                initialValues={{
                  teamMemberType: item.teamMemberType.id,
                  user: item.user.id,
                }}
              /> */}
              <DeleteButton userId={item.user.id} />
            </>
          ),
        };
        return obj;
      },
    },
  ];

  return (
    <ProTable
      loading={loading}
      columns={columns}
      dataSource={data?.team}
      pagination={false}
      search={false}
      toolBarRender={false}
      rowKey={({ user }) => user.id}
    />
  );
};

TeamTable.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

export default TeamTable;
